export { QRCode } from "./qr-code";
